module.exports = __webpack_public_path__ + "static/james-anthony-burandt-hero-small-215f6f6082a619a6c8300a44b89b5552.jpg";